export default __webpack_public_path__ + "static/media/paid-crown-icon.42fb4b57.svg";